import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import LoginComponent from '../components/Auth/LoginComponent';

const LoginPage = () => {
  return (
    <Container
      role="main"
      aria-label="Página de inicio de sesión"
    >
      <Row
        className="justify-content-center align-items-center min-vh-100"
        aria-live="polite"
      >
        <Col md={6} lg={4}>
          <Card aria-labelledby="login-card-title">
            <Card.Body>
              <h2
                className="text-center mb-4"
                id="login-card-title"
                aria-level="1"
              >
                Iniciar Sesión
              </h2>
              <LoginComponent
                aria-label="Formulario de inicio de sesión"
              />
              <div className="text-center mt-3">
                <Link
                  to="/recover-password"
                  aria-label="Recuperar contraseña. Enlace a la página de recuperación de contraseña"
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
